export default __webpack_public_path__ + "static/media/1.cee94d12.svg";